import {Select} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EmpresaBeneficiarioEmpresa} from '../../constants';

const {Apresentacao} = EmpresaBeneficiarioEmpresa;

export default function SelectEmpresaBeneficiarioEmpresaApresentacao(props) {
  const {t} = useTranslation();

  const createOption = ({id, label}) => (
      <Select.Option value={id}>
        {t(label)}
      </Select.Option>);

  return (
      <Select {...props} >
        {createOption(Apresentacao.Pendente)}
        {createOption(Apresentacao.Sim)}
        {createOption(Apresentacao.Nao)}
      </Select>
  );
}

SelectEmpresaBeneficiarioEmpresaApresentacao.propTypes = {
  value: PropTypes.oneOf([
    Apresentacao.Pendente.id,
    Apresentacao.Sim.id,
    Apresentacao.Nao.id]),
  onChange: PropTypes.func,
};
